import React from 'react';
import { makeStyles, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function BackButton(props) {
    const classes = useStyles();
    const { t } = useTranslation();


    let text = "";

    if(props.textOverride){
        text = props.textOverride
    }

    const action = () => {
        
    }

    return <Button onClick={props.action?() => props.action():action()}>
        <div className={classes.text}>
            {text}
        </div>
    </Button>
}

const useStyles = makeStyles({
    arrowBack: {
        color:FlagstoneTheme.palette.primary.main,
        width:"15px",
        height:"15px",
        float:"left"
    },
    text:{
        float:"left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform:"none"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
});